<canvas id="canvas" class="webgl"></canvas>
<div class="container-fluid">
    <header id="mobile-header" class="fixed-top">
        <div class="burger-menu burger-menu--closed">
            <div class="bar"></div>
            <div class="bar"></div>
            <div class="bar"></div>
        </div>
    </header>
</div>

<div id="offcanvas-full-container">
    <div id="offcanvas-content"
         class="has-animation animation-ltr">
        <div style="background-color: #1c1c1c; width: 100vw; height: 100vh; color: white">
        </div>
    </div>
</div>

<div id="smooth-wrapper">
    <div id="smooth-content">

        <section id="home" class="hero">
            <div class="container-fluid">
                <div class="d-flex align-items-center justify-content-center vh-100">
                    <h1 class="hero prevent-select"><span data-id="hero-telex" class="hero-telex"></span><span data-id="hero-telex-2" class="hero-telex"></span><span class="hero-cursor"><span class="progress-cursor"></span></span></h1>
                </div>
            </div>
        </section>

        <section id="leistungen" class="bg-light prevent-select">
            <div class="container-fluid p-6">
                <div class="row">
                    <div class="col-12">
                        <h6 class="headline-scramble mb-2" data-text="_ENGINEERED FOR EXCELLENCE">&nbsp;</h6>
                        <div class="reveal-container reveal-ltr">
                            <h2>SOFTWARE FÜR DIE, DIE MEHR WOLLEN</h2>
                        </div>
                        <p class="telex mt-2">
                            Bei <strong>aheadware</strong> entwickeln wir maßgeschneiderte Softwarelösungen, die sich von der Masse abheben. Wir setzen auf kreative Ansätze, die Technologie erlebbar machen und unseren Kunden neue Möglichkeiten bieten. Damit erschaffen wir Anwendungen, die Technik und Kreativität in Einklang bringen.
                        </p>
                        <p class="telex">
                            Unsere Expertise geht weit über die Standardprogrammierung hinaus. Unser Fokus liegt auf Effizienz, Robustheit und technischer Präzision - konzipiert und umgesetzt von einem Team, das die Technologie bis ins letzte Bit versteht. Wir sind Spezialisten für High-Performance-Lösungen, die den höchsten Standards an Leistung und Stabilität entsprechen und selbst anspruchsvollste Anforderungen erfüllen.
                        </p>
                    </div>
                </div>
                <div class="row gx-5" style="margin-top: 2rem!important;">
                    <div class="col-lg-6 mb-5 d-flex align-items-stretch">
                        <div class="reveal-container reveal-ltr"
                             style="width: 100%"
                             data-delay="0.2">
                            <div class="h-100 shine service-box-container">
                                <div class="service-box">
                                    <div class="service-box-icon">
                                        <i class="fa-regular fa-cart-shopping-fast"></i>
                                    </div>
                                    <div class="service-box-header">
                                        <span class="headline-scramble" data-text="DIGITALE GESCHÄFTSMODELLE">&nbsp;</span>
                                    </div>
                                    <div class="service-box-body">
                                        Wir entwickeln Lösungen, die neue digitale Geschäftsmodelle ermöglichen und Ihre Services auf eine skalierbare Plattform bringen.
                                    </div>
                                </div>
                                <a href="/serv/digital-business-saas">View more</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 mb-5 d-flex align-items-stretch">
                        <div class="reveal-container reveal-ltr"
                             style="width: 100%"
                             data-delay="0.4">
                            <div class="h-100 shine service-box-container">
                                <div class="service-box">
                                    <div class="service-box-icon">
                                        <i class="fa-light fa-game-console-handheld-crank"></i>
                                    </div>
                                    <div class="service-box-header">
                                        <span class="headline-scramble" data-text="3D, KREATIVE EFFEKTE & GAMIFICATION">&nbsp;</span>
                                    </div>
                                    <div class="service-box-body">
                                        Visuelle und interaktive Erlebnisse, die faszinieren und durch technologische Innovation überzeugen.
                                    </div>
                                </div>
                                <a href="/serv/games-creative-3d">View more</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 mb-5 d-flex align-items-stretch">
                        <div class="reveal-container reveal-ltr"
                             style="width: 100%"
                             data-delay="0.6">
                            <div class="h-100 shine service-box-container">
                                <div class="service-box">
                                    <div class="service-box-icon">
                                        <i class="fa-regular fa-puzzle-piece-simple"></i>
                                    </div>
                                    <div class="service-box-header">
                                        <span class="headline-scramble" data-text="PLUGIN-/API-ENTWICKLUNG">&nbsp;</span>
                                    </div>
                                    <div class="service-box-body">
                                        Erweiterungen und Integrationen für bestehende Systeme, um neue Funktionen zu ergänzen und die Möglichkeiten Ihrer Software zu erweitern.
                                    </div>
                                </div>
                                <a href="/serv/plugin-api-development">View more</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 mb-5 d-flex align-items-stretch">
                        <div class="reveal-container reveal-ltr"
                             style="width: 100%"
                             data-delay="0.8">
                            <div class="h-100 shine service-box-container">
                                <div class="service-box">
                                    <div class="service-box-icon">
                                        <i class="fa-regular fa-gear-code"></i>
                                    </div>
                                    <div class="service-box-header">
                                        <span class="headline-scramble" data-text="TOOLS & AUTOMATISIERUNG">&nbsp</span>
                                    </div>
                                    <div class="service-box-body">
                                        Maßgeschneiderte Anwendungen und Tools zur Automatisierung Ihrer Arbeitsprozesse, die Effizienz steigern und manuelle Arbeit minimieren.
                                    </div>
                                </div>
                                <a href="/serv/tools-automation">View more</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12">
                        <p class="telex">
                            Wir bieten Ihnen plattformnahe, optimierte und individuell zugeschnittene Anwendungen. Von High-Performance-Systemen für industrielle Anwendungen bis hin zu kreativen Lösungen für interaktive Erlebnisse. <strong>aheadware</strong> ist Ihr Partner für innovative, maßgeschneiderte Softwareprojekte.
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <section id="portfolio" class="bg-white">
            <div class="container-fluid p-6">
                <div class="row">
                    <div class="col-xl-4">
                        <h6 class="headline-scramble mb-2" data-text="_INNOVATION IN ACTION">&nbsp;</h6>
                        <div class="reveal-container reveal-ltr">
                            <h2>Referenzen</h2>
                        </div>
                    </div>
                    <div class="col-xl-8">
                        <h6>&nbsp;</h6>
                        <p class="telex mt-2">
                            Unsere Arbeit hinterlässt Spuren – in Projekten, die komplexe Herausforderungen meistern, und Lösungen, die auch unter Hochlast bestehen. In enger Zusammenarbeit mit unseren Kunden haben wir eine Vielzahl von Projekten umgesetzt, die Effizienz, Stabilität und kreative Finesse vereinen. Hier ein Einblick in einige unserer erfolgreichsten Anwendungen und Partnerschaften, die zeigen, was möglich ist, wenn man Technologie auf den Punkt bringt.
                        </p>
                    </div>
                </div>
                <div class="row gx-5" style="margin-top: 4rem">

                    <div class="col-lg-6 mb-5 align-items-stretch">
                        <div class="h-100">
                            <div class="ref-container">
                                <div class="ref-container-img" style="background-image: url(/assets/images/references/ref-actiboard-full.jpg)"></div>
                                <div class="ref-container-box">
                                    <div class="ref-container-header">
                                        <span class="headline-scramble" data-text="ACTIBOARD">&nbsp;</span>
                                    </div>
                                    <div class="ref-container-body">
                                        IOS APP FÜR WONDERMORE GAMES STUDIO
                                    </div>
                                </div>
                                <a href="/ref/actiboard">View more</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 mb-5 align-items-stretch">
                        <div class="h-100">
                            <div class="ref-container">
                                <div class="ref-container-img" style="background-image: url(/assets/images/references/ref-diversitize-logo.png)"></div>
                                <div class="ref-container-box">
                                    <div class="ref-container-header">
                                        <span class="headline-scramble" data-text="DIVERSITIZE">&nbsp;</span>
                                    </div>
                                    <div class="ref-container-body">
                                        SAAS ANWENDUNG FÜR DIVERSITIZE GMBH
                                    </div>
                                </div>
                                <a href="/ref/diversitize-app">View more</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 mb-5 align-items-stretch">
                        <div class="h-100">
                            <div class="ref-container">
                                <div class="ref-container-img" style="background-image: url(/assets/images/references/ref-enportal-connect.jpg)"></div>
                                <div class="ref-container-box">
                                    <div class="ref-container-header">
                                        <span class="headline-scramble" data-text="ENPORTAL CONNECT">&nbsp;</span>
                                    </div>
                                    <div class="ref-container-body">
                                        SYSTEMINTEGRATION UND ENTWICKLUNG FÜR ENPORTAL
                                    </div>
                                </div>
                                <a href="/ref/enportal-connect">View more</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 mb-5 align-items-stretch">
                        <div class="h-100">
                            <div class="ref-container">
                                <div class="ref-container-img" style="background-image: url(/assets/images/references/ref-enportal-compete.jpg)"></div>
                                <div class="ref-container-box">
                                    <div class="ref-container-header">
                                        <span class="headline-scramble" data-text="ENPORTAL COMPETE">&nbsp;</span>
                                    </div>
                                    <div class="ref-container-body">
                                        CLIENT ENTWICKLUNG FÜR ENPORTAL
                                    </div>
                                </div>
                                <a href="/ref/enportal-compete">View more</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 mb-5 align-items-stretch">
                        <div class="h-100">
                            <div class="ref-container">
                                <div class="ref-container-img" style="background-image: url(/assets/images/references/ref-hipercomponents.jpg)"></div>
                                <div class="ref-container-box">
                                    <div class="ref-container-header">
                                        <span class="headline-scramble" data-text="HIGH PERFORMANCE KOMPONENTEN">&nbsp;</span>
                                    </div>
                                    <div class="ref-container-body">
                                        KOMPONENTEN-ENTWICKLUNG FÜR HD AUTOMATION
                                    </div>
                                </div>
                                <a href="/ref/highperformance-components">View more</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 mb-5 align-items-stretch">
                        <div class="h-100">
                            <div class="ref-container">
                                <div class="ref-container-img" style="background-image: url(/assets/images/references/ref-jubeldeal-screen.jpg)"></div>
                                <div class="ref-container-box">
                                    <div class="ref-container-header">
                                        <span class="headline-scramble" data-text="JUBELDEAL">&nbsp;</span>
                                    </div>
                                    <div class="ref-container-body">
                                        GEWINNSPIEL MICROSITE FÜR ALDI SUISSE
                                    </div>
                                </div>
                                <a href="/ref/jubeldeal">View more</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 mb-5 align-items-stretch">
                        <div class="h-100">
                            <div class="ref-container">
                                <div class="ref-container-img" style="background-image: url(/assets/images/references/ref-supermarquee.jpg)"></div>
                                <div class="ref-container-box">
                                    <div class="ref-container-header">
                                        <span class="headline-scramble" data-text="SUPERMARQUEE">&nbsp;</span>
                                    </div>
                                    <div class="ref-container-body">
                                        HTML5 WEB COMPONENT FÜR SUPERPLUG.IN
                                    </div>
                                </div>
                                <a href="/ref/supermarquee">View more</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 mb-5 align-items-stretch">
                        <div class="h-100">
                            <div class="ref-container">
                                <div class="ref-container-img" style="background-image: url(/assets/images/references/ref-youtine-cover.jpg)"></div>
                                <div class="ref-container-box">
                                    <div class="ref-container-header">
                                        <span class="headline-scramble" data-text="YOUTINE">&nbsp;</span>
                                    </div>
                                    <div class="ref-container-body">
                                        CROSS-PLATTFORM ENTWICKLUNG FÜR YOUTINE
                                    </div>
                                </div>
                                <a href="/ref/youtine">View more</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </section>

        <section id="technology" class="bg-light">
            <div class="container-fluid p-6" style="padding-bottom: 0!important">
                <div class="row">
                    <div class="col-xl-4">
                        <h6 class="headline-scramble mb-2" data-text="_OUTPERFORMING THE ORDINARY">&nbsp;</h6>
                        <div class="reveal-container reveal-ltr">
                            <h2>Technologie</h2>
                        </div>
                    </div>
                    <div class="col-xl-8">
                        <h6>&nbsp;</h6>
                        <p class="telex mt-2">
                            In einer Welt mit immer komplexeren Komponenten und Frameworks setzen wir bei <strong>aheadware</strong> auf das Wesentliche: Technologie, die passt und performt. Für uns ist Software kein Einheitsbrei. Jedes Projekt verdient eine präzise Auswahl von Komponenten, die nicht nur robust, sondern auch extrem effizient arbeiten. Wir wählen Technologien bewusst und mit dem Ziel aus, eine solide, stabile und performante Basis zu schaffen – ohne Ballast, der Leistung und Klarheit bremst.
                        </p>
                        <p class="telex">
                            Unsere Lösungen sind so entwickelt, dass sie das Maximum aus jeder Plattform herausholen. Das Ergebnis? Schneller, plattform naher Code, der funktioniert – und das auch unter hoher Belastung und langfristigem Einsatz. Die folgenden Technologien bilden das solide Fundament unserer Arbeiten.
                        </p>
                    </div>
                </div>
            </div>
            <div class="row" style="margin-top: 4rem; padding-bottom: 4rem;">
                <div class="col-12">
                    <div id="tech-scroller"></div>
                </div>
            </div>

        </section>

        <section id="about" class="bg-light">
            <div class="container-fluid p-6" style="padding-bottom: 4rem !important;padding-top: 4rem !important;">
                <div class="row">
                    <div class="col-xl-6">
                        <h6 class="headline-scramble mb-2" data-text="_THEY CALL US NERDS">&nbsp;</h6>
                        <div class="reveal-container reveal-ltr">
                            <h2>Über uns</h2>
                        </div>
                        <p class="telex mt-2">
                            Wir sind ein Team aus internationalen Software Entwicklern, Designern und Experten, die ihre Expertise aus unterschiedlichsten Projekten und Kulturen einbringen. Mit einer komplett digitalen Aufstellung arbeiten wir grenzenlos und nutzen die besten Köpfe weltweit, um außergewöhnliche Softwarelösungen zu schaffen. Jedes Teammitglied bringt spezifisches Know-how und frische Perspektiven in die Projekte ein, sei es in der Entwicklung, im Design oder an den Schnittstellen dazwischen.
                        </p>
                        <p class="telex">
                            Unsere Zusammenarbeit ist digital, flexibel und fokussiert. Ob beim Coding in Echtzeit oder im kreativen Austausch für Design und UX – wir nutzen modernste Tools und klare Kommunikationsstrukturen, die auch über Zeitzonen hinweg ein nahtloses Arbeiten ermöglichen. So entstehen Lösungen, die Technik und Kreativität in perfekter Harmonie vereinen.
                        </p>
                        <!---
                        <p>
                          Wir freuen uns immer über Kontakt zu neuen Talenten. Einfach Portfolio samt CV an<br />
                          <button class="btn btn-dark mt-2">career@aheadware.com</button>
                        </p>
                        -->
                    </div>
                    <div class="col-xl-6">
                        <div class="h-100" style="width: 100%; min-height:33vh; max-height: 50vh">
                            <canvas id="about-us-canvas" style="width:100%;height:100%"></canvas>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section id="contact" class="bg-light">
            <div class="container-fluid p-6" style="padding-bottom: 2rem!important; padding-top: 4rem!important;">
                <div class="inner-container">
                    <div class="row gx-5">
                        <div class="col-xl-6">
                            <h6 class="headline-scramble mb-2" data-text="_GET INVOLVED">&nbsp;</h6>
                            <div class="reveal-container reveal-ltr">
                                <h2>Kontakt</h2>
                            </div>
                            <p class="telex">
                                Egal, ob Sie eine Idee haben, eine Beratung suchen oder direkt in die Umsetzung starten möchten – wir sind nur eine Nachricht entfernt. Teilen Sie uns mit, was Sie vorhaben, und wir finden gemeinsam heraus, wie wir Ihre Vision in die Realität umsetzen können. Füllen Sie einfach das Formular aus, und unser Team meldet sich schnellstmöglich bei Ihnen.
                            </p>
                            <h4 class="headline-scramble" style="margin-top: 4rem; margin-bottom: 2rem;" data-text="Unser Büro südlich von Hamburg">&nbsp;</h4>
                            <p class="telex">
                                <i class="fa-regular fa-location-dot"></i> aheadware GmbH, Marie-Curie-Str.12, 21337 Lüneburg
                            </p>
                            <p class="telex">
                                <i class="fa-regular fa-phone"></i> +49(0)-4131-217 40 60
                            </p>
                            <p class="telex">
                                <i class="fa-regular fa-envelope"></i> hello@aheadware.com
                            </p>
                        </div>
                        <div class="col-xl-6" style="margin-bottom: 48px;">
                            <form data-id="contact-form"
                                  class="inner-form-box">
                                <div class="mb-3">
                                    <label for="name" class="form-label telex">Wie heißen Sie?</label>
                                    <input type="text" class="form-control" id="name" name="name" placeholder="Name" required>
                                </div>
                                <div class="mb-3">
                                    <label for="email" class="form-label telex">Wie lautet Ihre E-Mail Adresse?</label>
                                    <input type="email" class="form-control" id="email" name="email" placeholder="name@example.com" required>
                                </div>
                                <div class="mb-3">
                                    <label for="phone" class="form-label telex">Unter welcher Telefonnummer können wir Sie erreichen?</label>
                                    <input type="text" class="form-control" id="phone" name="phone" placeholder="+49(0)....">
                                </div>
                                <div class="mb-3">
                                    <label for="message" class="form-label telex">Erzählen Sie von Ihrem Vorhaben</label>
                                    <textarea class="form-control" id="message" name="message" rows="3" required></textarea>
                                </div>
                                <div class="mb-3">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="" id="acceptdataprivacy" required>
                                        <label class="form-check-label small telex" for="acceptdataprivacy">
                                            Ich habe die <a href="/legal/datenschutz">Datenschutzerklärung</a> zur Kenntnis genommen und stimme zu, dass meine Anfragen zur Kontaktaufnahme und für Rückfragen zweckbestimmt gespeichert werden.
                                        </label>
                                    </div>
                                </div>
                                <button class="btn btn-lg btn-shine"
                                        type="submit"
                                        data-id="btn-submit-contact-form"
                                        style="width: 100%">
                                    <span class="btn-contact-submit">Senden</span>
                                    <span class="btn-contact-loading"><i class="fa-regular fa-gear fa-spin"></i></span>
                                    <span class="btn-contact-received">Vielen Dank für die Anfrage - Wir melden uns!</span>
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <footer class="footer bg-light p-6" style="padding-top: 4rem!important; padding-bottom: 4rem!important">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-xl-12">
                        <img src="/assets/images/ahd-icon.svg" style="width: 64px;margin-bottom: 8px" />
                        <p style="margin-top: 12px">
                            aheadware Gmbh · Marie-Curie-Str. 12 · 21337 Lüneburg | +49(0)-4131-217 40 60 | hello@aheadware.com
                        </p>
                    </div>
                    <div class="col-xl-8">
                        <p>
                            <a href="/legal/impressum">IMPRESSUM</a> | <a href="/legal/agb">AGB</a> | <a href="/legal/disclaimer">HAFTUNGSAUSSCHLUSS</a> | <a href="/legal/datenschutz">DATENSCHUTZERKLÄRUNG</a>
                        </p>
                    </div>
                    <div class="col-xl-4 align-self-end">
                        <p style="text-align: right">
                            Engineering with <i class="fa-regular fa-computer-classic"></i> and <i class="fa-solid fa-binary"></i> since 1337
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</div>
